/** AUTO-GENERATED by scripts/gen-definitions.ts - do not edit */

import abi_5c06b1840e1e from "../abis/5c06b1840e1e307bec4b426803081be2250b1a16a89ed3a3272000bfc5fd0d8f.json";
import abi_77be5f07a2c0 from "../abis/77be5f07a2c0458cde3a847eb4ea83cf0f6686a738a0717baa86936aa2e589fa.json";
import abi_bc37a8c681af from "../abis/bc37a8c681af0849ace7cde4b7005b58679dff2abe8276aaedbdeb31e77ee0e9.json";
import abi_ff0785f2d6ec from "../abis/ff0785f2d6ec18ac54f04caf8944b32e80931b6e0ba747eea0e46e53494cbb12.json";
import type { ChainDefinitionsBundle } from "../bundle-types.js";
import manifest from "../chains/local/deployments/local/manifest.json";

export const definitions = {
	latest: {
		FSEnvelopeRegistry: {
			address: "0x73511669fd4dE447feD18BB79bAFeAC93aB7F31f",
			abi: abi_ff0785f2d6ec,
		},
		FSPaymentValidator: {
			address: "0xB581C9264f59BF0289fA76D61B2D0746dCE3C30D",
			abi: abi_5c06b1840e1e,
		},
		FSAttachmentRelease: {
			address: "0xC469e7aE4aD962c30c7111dc580B4adbc7E914DD",
			abi: abi_bc37a8c681af,
		},
		MockUSDC: {
			address: "0x6d925938Edb8A16B3035A4cF34FAA090f490202a",
			abi: abi_77be5f07a2c0,
		},
	},
	deploymentId: manifest.deploymentId,
	historicalByAddress: {},
} satisfies ChainDefinitionsBundle;
